import { Component, OnInit } from '@angular/core';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { map, Observable, switchMap } from 'rxjs';

import { CmsArticle, CmsCollection } from '@fcom/core-api/interfaces';
import { IconButtonSize, IconButtonTheme } from '@fcom/ui-components/components/buttons';
import { LanguageService } from '@fcom/ui-translate/services/language.service';
import { CmsDataService } from '@fcom/core/services';
import { GtmService } from '@fcom/common/gtm';
import { toKebabCase } from '@fcom/ui-components/utils/string.utils';
import { ElementTypes, GaContext } from '@fcom/common/interfaces';

@Component({
  selector: 'fin-image-cards',
  templateUrl: './image-cards.component.html',
  styleUrl: './image-cards.component.scss',
})
export class ImageCardsComponent implements OnInit {
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  cards$: Observable<CmsArticle[]>;

  constructor(
    private languageService: LanguageService,
    private cmsDataService: CmsDataService,
    private gtmService: GtmService
  ) {}

  ngOnInit(): void {
    this.cards$ = this.languageService.translate('CORPORATE.fragments.corporatePortal.adCards.url').pipe(
      switchMap((url) => this.cmsDataService.getFragmentJson<CmsCollection>(url)),
      map((fragment) => fragment.items as CmsArticle[])
    );
  }

  trackEvent(card: CmsArticle): void {
    const headerWithoutTags = (card.teaserText || '').replace(/<[^>]*>/g, '');
    const elem = `corporate-portal-cta-${toKebabCase(headerWithoutTags)}`;
    this.gtmService.trackElement(elem, GaContext.CORPORATE_PORTAL, ElementTypes.LINK, undefined, 'click');
  }
}
